module.exports = __webpack_public_path__ + "c6b480f63e624f2156677f71f943c59b.pdf";